import React from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "src/ui/shared/toasts/Toasts";

import { fetchOauthClient } from "../api/client";

export const useGetOauthClient = (clientId: string) => {
    const [data, setData] = React.useState<API.OauthClient | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);

    const { t } = useTranslation(["pages"]);

    React.useEffect(() => {
        setIsLoading(true);
        void fetchOauthClient(clientId)
            .then((response) => setData(response.model))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err?.message || t("pages:adminOauthClientsPage.toast.oauthClientFetchError"));
            })
            .finally(() => setIsLoading(false));
    }, [clientId, t]);

    return { data, isLoading };
};
